import { useState } from 'react'
import ImageContainer from './ImageContainer'
import Uploading from './Uploading'
import ImageAfterUpdoad from './ImageAfterUpdoad'

function UploadIndex(props) {
  const [isUploading, setIsUploading] = useState(false)
  const [imageData, setImageData] = useState([])
  const [uploaded, setUploaded] = useState(false)
  const [url, setUrl] = useState('')

  return (
    <div className='app'>
      {isUploading ? (
        <Uploading />
      ) : (
        !uploaded && (
          <ImageContainer
            setImageData={setImageData}
            setIsUploading={setIsUploading}
            setUploaded={setUploaded}
            url={url}
            setUrl={setUrl}
            flag={props.flag}
            id={props.id}
            ext={props.ext}
          />
        )
      )}
      {uploaded && (
        <ImageAfterUpdoad
          url={url}
          setUrl={setUrl}
          imageData={imageData}
        />
      )}
    </div>
  )
}

export default UploadIndex